import { render } from "./UserOptionsComponent.vue?vue&type=template&id=0fc0ebf2&scoped=true"
import script from "./UserOptionsComponent.vue?vue&type=script&lang=js"
export * from "./UserOptionsComponent.vue?vue&type=script&lang=js"

import "./UserOptionsComponent.vue?vue&type=style&index=0&id=0fc0ebf2&scoped=true&lang=css"

import exportComponent from "/Users/alejandrobernal/Documents/fbc/fbc-ecommerce-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc0ebf2"]])

export default __exports__